module.exports = __webpack_public_path__ + "img/placeholder_4.031825ca.svg";